import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Start from '../src/pages/start';
import Meetus1 from '../src/pages/meetus1';
import Meetus2 from './pages/meetus2';
import Meetus3 from './pages/meetus3';
import Meetus4 from './pages/meetus4';
import Login from './pages/login';
import Signup from './pages/signup';
import Home from './pages/home'
import DesignersStack from './pages/designers';
import DesignerDetails from './pages/DesignerDetails';
import Schedule from './pages/schedule';
import Tickets from './pages/tickets';
import Rate from './pages/rate';
import Myticket from './pages/myticket';
import ErrorPage from './pages/error';
import Map from './pages/map';
import Booking from './pages/booking';


const Paths = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/meetus1" element={<Meetus1 />} />
        <Route path="/meetus2" element={<Meetus2 />} />
        <Route path="/meetus3" element={<Meetus3 />} />
        <Route path="/meetus4" element={<Meetus4 />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/home" element={<Home />} />
        <Route path="/designers" element={<DesignersStack />} />
        <Route path="/designerdetails" element={<DesignerDetails/>} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/rate" element={<Rate />} />
        <Route path="/myticket" element={<Myticket />} />
        <Route path="map" element={<Map />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="booking" element={<Booking />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Paths;